module.exports = __webpack_public_path__ + "assets/img/crayon8.7a96e8ef.png";